import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";
import { useLanguage } from "@/context/LanguageContext";
import { Panel } from "@/components/ui/Panel";
import { BellIcon, ChatBubbleLeftIcon } from "@heroicons/react/24/outline";

export function WatchDogOverviewCreatePanel() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      management: "Správa hlídání",
      watchdog: "Hlídací pes",
      watchdogText:
        "Rozšiřte si sledování nových nabídek a mějte každého psa připraveného v přehledu i analytice.",
      customSetup: "Úprava na míru",
      customSetupText:
        "Potřebujete více hlídacích psů? Upravit psa na míru? Napište nám",
    },
    en: {
      management: "Watchdog management",
      watchdog: "Watchdog",
      watchdogText:
        "Expand your tracking of new offers and keep each watchdog ready in overview and analytics.",
      customSetup: "Custom setup",
      customSetupText:
        "Need more watchdogs or a custom watchdog setup? Write to us",
    },
  }[language];

  return (
    <Panel>
      <div className="space-y-1">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.management}
        </PortfolioPageSectionBadge>
      </div>

      <div className="mt-4 space-y-2">
        <PortfolioPageInsightItem
          icon={BellIcon}
          title={copy.watchdog}
          text={copy.watchdogText}
        />
        <PortfolioPageInsightItem
          icon={ChatBubbleLeftIcon}
          title={copy.customSetup}
          text={copy.customSetupText}
        />
      </div>
    </Panel>
  );
}
